module.exports = __webpack_public_path__ + "img/greywinter.02cfeaa4.png";